// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const ExtensionsIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="ExtensionsIcon" ref={forwardedRef} {...props}>
      <path d="M3 9.623a3.47 3.47 0 0 1 1.75-3.035l7.125-4.114c2.333-1.347 5.25.337 5.25 3.031v8.228c0 2.694-2.917 4.378-5.25 3.03l-6.984-4.032a3.5 3.5 0 0 1-.71-.487 3.44 3.44 0 0 1-1.108-1.905A3.5 3.5 0 0 1 3 9.623m4.985-3.171a3.5 3.5 0 0 1 .007 6.337l4.633 2.675c1.333.77 3-.192 3-1.732V5.506c0-1.54-1.667-2.502-3-1.732zM4.59 10.214a2 2 0 0 0 .91 1.137l.102.059a2 2 0 1 0-1.013-1.196" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const ExtensionsIcon = /* @__PURE__ */ Object.assign(
  ExtensionsIconComponent,
  { displayName: 'ExtensionsIcon' },
);
